import { entrypoints as accountEntrypoints } from "./account/entrypoint.ts";
import { entrypoints as accountsEntrypoints } from "./accounts/entrypoint.ts";
import { entrypoints as adEntrypoints } from "./ad/entrypoint.ts";
import { entrypoints as adsetEntrypoints } from "./adset/entrypoint.ts";
import { entrypoints as authEntrypoints } from "./auth/entrypoint.ts";
import { entrypoints as campaignEntrypoints } from "./campaign/entrypoint.ts";
import { entrypoints as changeEntrypoints } from "./change/entrypoint.ts";
import { entrypoints as conversationEntrypoints } from "./conversation/entrypoint.ts";
import { entrypoints as conversationsEntrypoints } from "./conversations/entrypoint.ts";
import { entrypoints as journalEntrypoints } from "./journal/entrypoint.ts";
import { entrypoints as overviewEntrypoints } from "./overview/entrypoint.ts";
import { entrypoints as peopleEntrypoints } from "./people/entrypoint.ts";
import { entrypoints as rulesEntrypoints } from "./rules/entrypoint.ts";

export const contributions = [
  accountEntrypoints, accountsEntrypoints, adEntrypoints, adsetEntrypoints, authEntrypoints, campaignEntrypoints, changeEntrypoints,
  conversationEntrypoints, conversationsEntrypoints, journalEntrypoints, overviewEntrypoints, peopleEntrypoints, rulesEntrypoints,
];
